import { Formik } from 'formik'
import React from 'react'
import * as yup from 'yup'
import { Button, FormField, FormInput, FormLayout } from '@next-nx/shared-ui/atoms'

const validationSchema = yup.object().shape({
  email: yup
    .string()
    .required('Questo campo è obbligatorio')
    .email("Il formato dell'email dev'essere valido")
    .nullable(),
})

const FormRecuperaPassword = () => {
  const initialValues = {
    email: null,
  }

  return (
    <Formik
      isInitialValid={false}
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={(values) => console.log('Recupera Password', values)}
    >
      {(props) => (
        <FormLayout>
          <FormField
            label="Email*"
            status={props.touched.email ? (props.errors.email ? 'error' : 'success') : null}
            errorMessage={props.errors.email as string}
          >
            <FormInput
              value={props.values.email}
              onBlur={props.handleBlur('email')}
              onChange={props.handleChange('email')}
              placeholder="Inserisci la tua email"
            />
          </FormField>

          <Button
            disabled={!!props.errors.email || !props.dirty}
            variant="primary"
            label="Invia"
            onClick={() => props.handleSubmit()}
            type="submit"
          />
        </FormLayout>
      )}
    </Formik>
  )
}

export default FormRecuperaPassword
